import * as Yup from "yup";

import { LineAdditionalServiceType } from "../interfaces";

const zipCodePattern = /^\d{8}$/;
const imeiPattern = /^\d{15}$/;
const eidPattern = /^\d{32}$/;

const getDetailsSchema = (isChargeExempt: boolean) =>
  isChargeExempt
    ? Yup.string()
        .trim()
        .required("Informe detalhes sobre a isenção.")
        .test("minimum-word-count", "Informe mais detalhadamente.", value =>
          Boolean(value && value.split(/\s+/).length >= 3)
        )
    : Yup.string().trim().optional();

const eSimInfoSchema = Yup.object({
  IMEI: Yup.string()
    .matches(imeiPattern, "O IMEI deve conter 15 dígitos numéricos.")
    .required(),

  EID: Yup.string()
    .matches(eidPattern, "O EID deve conter 32 dígitos numéricos.")
    .required(),

  deviceModel: Yup.string().trim().required("Informe o modelo do aparelho.")
});

const deliveryAddressSchema = Yup.object({
  zipCode: Yup.string()
    .transform((value: unknown) =>
      typeof value === "string" ? value.replace(/\D/g, "") : ""
    )
    .matches(zipCodePattern, "O CEP deve conter 8 dígitos numéricos.")
    .required("Informe o CEP."),

  city: Yup.string().trim().required("Informe a cidade."),

  state: Yup.string().trim().required("Informe o estado."),

  street: Yup.string().trim().required("Informe o logradouro."),

  neighborhood: Yup.string().trim().required("Informe o bairro."),

  number: Yup.string().trim().optional(),

  note: Yup.string().trim().optional()
});

const getPhysicalChipNotesSchema = (isChargeExempt: boolean) =>
  Yup.object({
    details: getDetailsSchema(isChargeExempt),
    deliveryAddress: deliveryAddressSchema.required()
  });

const getESimNotesSchema = (isChargeExempt: boolean) =>
  Yup.object({
    details: getDetailsSchema(isChargeExempt),
    eSimInfo: eSimInfoSchema.required()
  });

export const lineAdditionalServiceFormSchema = Yup.object({
  type: Yup.mixed<LineAdditionalServiceType>().required(),
  isChargeExempt: Yup.boolean().required(),
  dataBonusGb: Yup.number().when("type", ([type], schema) =>
    type === LineAdditionalServiceType.DATA_BONUS
      ? schema
          .integer("Informe uma quantidade inteira.")
          .min(1, "Informe uma quantidade maior que zero.")
          .max(999, "Informe uma quantidade de até 999 GB.")
          .required("Informe a quantidade.")
      : schema.optional()
  ),
  notes: Yup.object().when(
    ["type", "isChargeExempt"],
    ([type, isChargeExempt], schema) => {
      if (type === LineAdditionalServiceType.PHYSICAL_CHIP) {
        return getPhysicalChipNotesSchema(Boolean(isChargeExempt));
      }

      if (type === LineAdditionalServiceType.ESIM) {
        return getESimNotesSchema(Boolean(isChargeExempt));
      }

      if (type === LineAdditionalServiceType.DATA_BONUS) {
        return Yup.object({
          details: getDetailsSchema(Boolean(isChargeExempt))
        });
      }

      return schema.optional();
    }
  )
});
